module.exports = __webpack_public_path__ + "img/image6.1e7f291d.png";